// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-super-text_root__fkd50"};